import { showDialog } from "../../../actions";
import { UserCanceled } from "../../../util/CustomErrors";
import { activeGameId, discoveryByGame, gameName, knownGames, } from "../../../util/selectors";
import { SITE_ID } from "../../gamemode_management/constants";
import { convertGameIdReverse, nexusGameId, } from "../../nexus_integration/util/convertGameId";
/**
 * Determine which game to install a download for.
 * If the currently managed game is compatible, just pick that, otherwise ask the user
 */
function queryGameId(store, downloadGameIds, fileName) {
    const state = store.getState();
    const gameMode = activeGameId(state);
    if (!Array.isArray(downloadGameIds)) {
        downloadGameIds = [downloadGameIds];
    }
    if (gameMode === undefined && downloadGameIds.length === 1) {
        // Surely if there's no active game, and the downloaded game id
        //  array contains a single element, then we can just use that.
        return Promise.resolve(downloadGameIds[0]);
    }
    if (downloadGameIds.indexOf(gameMode) !== -1) {
        // the managed game is compatible to the archive so use that
        return Promise.resolve(gameMode);
    }
    // Check for game ID conversion compatibility (e.g., skyrimse <-> skyrimspecialedition)
    const games = knownGames(state);
    const currentGame = games.find((game) => game.id === gameMode);
    if (currentGame) {
        // Check if any downloadGameIds match when converted to internal IDs
        const convertedDownloadIds = downloadGameIds.map((id) => convertGameIdReverse(games, id));
        if (convertedDownloadIds.indexOf(gameMode) !== -1) {
            return Promise.resolve(gameMode);
        }
        // Check if current game's nexus ID matches any downloadGameIds
        const currentGameNexusId = nexusGameId(currentGame);
        if (downloadGameIds.indexOf(currentGameNexusId) !== -1) {
            return Promise.resolve(gameMode);
        }
    }
    if (downloadGameIds.length === 1 &&
        downloadGameIds[0] === SITE_ID &&
        fileName.toLowerCase().includes("extension")) {
        return Promise.resolve(downloadGameIds[0]);
    }
    const profiles = state.persistent.profiles;
    const profileGames = new Set(Object.keys(profiles).map((profileId) => profiles[profileId].gameId));
    // we only offer to install for games that are managed because for others the user
    // doesn't have a direct way to configure the install directory
    const managed = downloadGameIds.filter((gameId) => profileGames.has(gameId) &&
        discoveryByGame(state, gameId)?.path !== undefined);
    // ask the user
    return new Promise((resolve, reject) => {
        const options = [
            { label: "Cancel", action: () => reject(new UserCanceled()) },
        ];
        if (gameMode !== undefined) {
            options.push({
                label: gameName(state, gameMode),
                action: () => resolve(gameMode),
            });
        }
        if (managed.length === 0) {
            store.dispatch(showDialog("question", "No compatible game being managed", {
                text: "The game(s) associated with this download are not managed, " +
                    "Install for the currently managed game?",
                message: fileName,
            }, options));
        }
        else {
            store.dispatch(showDialog("question", "Download is for a different game", {
                text: "The download is not marked compatible with the managed game. " +
                    "Which one do you want to install it for?",
                message: fileName,
            }, options.concat(managed.map((gameId) => ({
                label: gameName(store.getState(), gameId),
                action: () => resolve(gameId),
            })))));
        }
    });
}
export default queryGameId;
